/**
 * @file Waitlist Form
 */

/**
 * Waitlist Form component
 */
const vWaitlistForm = () => {
	const waitlistForm = document.querySelector( '.v-waitlist-form' );

	if ( ! waitlistForm ) {
		return;
	}

	const radios    = waitlistForm.querySelectorAll( '.v-waitlist-form__radio-original' );
	const tierInput = waitlistForm.querySelector( '.v-waitlist-form__radio-tier' );
	const nmls      = waitlistForm.querySelector( '.v-waitlist-form__nmls' );
	const dataLayer = window.dataLayer || [];

	if ( radios.length ) {
		/**
		 * Set the initial value of the hidden input to the selected radio's selected dropdown value
		 */
		const setInitialTierValue = () => {
			const checkedRadio  = waitlistForm.querySelector( '.v-waitlist-form__radio-original:checked' );
			const radioParent   = checkedRadio.closest( '.v-waitlist-form__radio-label' );
			const selected      = radioParent.querySelector( '[aria-selected="true"]' );
			const selectedLabel = selected.getAttribute( 'data-label' );
			const selectedCost  = selected.getAttribute( 'data-cost' );

			tierInput.value                                                   = `${ selectedLabel } Reports`;
			radioParent.querySelector( '.v-waitlist-form__cost' ).textContent = selectedCost;
		};

		[ ...radios ].forEach( ( radio ) => {
			const radioParent = radio.closest( '.v-waitlist-form__radio-label' );
			const cardCost    = radioParent.querySelector( '.v-waitlist-form__cost' );

			radio.addEventListener( 'change', ( e ) => {
				const { target } = e;

				if ( ! target.checked ) {
					return;
				}

				const parent    = target.closest( '.v-waitlist-form__radio-label' );
				const prevValue = parseInt( tierInput, 10 );
				const dd        = parent.querySelector( '.v-waitlist-form__dd' );
				const active    = dd.querySelector( '[aria-activedescendant]' );
				const label     = dd.querySelector( `#${ active.getAttribute( 'aria-activedescendant' ) }` ).getAttribute( 'data-label' );
				const newVal    = parseInt( label, 10 );

				if ( prevValue !== newVal ) {
					tierInput.value = `${ label } Reports`;
				}
			} );

			document.addEventListener( 'vReportsDropdownChange', ( { detail } ) => {
				const { target } = detail;

				if ( ! radioParent.contains( target ) ) {
					return;
				}

				cardCost.textContent = detail.cost;
				tierInput.value      = `${ detail.label } Reports`;

				// mark the radio as checked
				if ( ! radio.checked ) {
					[ ...radios ].forEach( ( r ) => r.checked = false );
					radio.checked = true;
				}
			} );
		} );

		// on load set hidden input value to selected radio's selected dropdown value
		setInitialTierValue();
	}

	if ( nmls ) {
		// limit input to numbers only
		nmls.addEventListener( 'input', ( e ) => {
			const { target } = e;
			const { value }  = target;

			target.value = value.replace( /\D/g, '' );
		} );
	}

	document.addEventListener( 'wpcf7mailsent', () => {
		waitlistForm.classList.add( 'v-waitlist-form--submitted' );
		dataLayer.push( {
			event:         'wpcf7submit',
			formId:        'v-waitlist-form',
			eventCategory: 'Form',
			eventAction:   'Submit',
			eventLabel:    'Waitlist Form',
		} );
	} );
};

export default vWaitlistForm;
